import React from "react";

import { Global, css } from "@emotion/react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Spellbook } from "./containers/Spellbook";

const theme = extendTheme({
  fonts: {
    body: "'Courgette', cursive",
    heading: "'Roboto Slab', serif",
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Global
        styles={css`
          html,
          body {
            background-color: black !important;
            --chakra-ui-color-mode: dark !important;
          }
        `}
      />
      <Spellbook />
    </ChakraProvider>
  );
}

export default App;
